import React from "react";
import "../scss/QuestionTypeFilter.scss";

const types = ["Principal", "Teacher", "Both"];

const QuestionTypeFilter = ({ value, onChange = () => {} }) => (
  <div className="question-type-filter">
    <span className="question-type-label">View data from:</span>
    {types.map((type) => (
      <button
        key={type}
        type="button"
        className={`question-type-btn${value === type ? " selected" : ""}`}
        onClick={() => onChange(type)}
        aria-pressed={value === type}
      >
        {type}
      </button>
    ))}
  </div>
);

export default QuestionTypeFilter;
